import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

// store
import { useStoreValue } from '../../../../../../store';

// components
import PlusIcon from '../../../../../../icons/PlusIcon';
import ModalUploadCueSheetWithClip from '../../../../../../components/ModalUploadCueSheetWithClip';
import ListOfSfxItems from './components/ListOfSfxItems';
import ListOfMixItems from './components/ListOfMixItems';

const AudioList = () => {
    const { projectId } = useParams();
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const myStudioAudioPanel = useStoreValue('myStudioAudioPanel');

    const [showUploadModal, setShowUploadModal] = useState(false);

    return (
        myStudioLeftPanel === 'audio'
            ? <>
                <OverlayScrollbarsComponent element="div" options={{ scrollbars: { autoHide: 'never' } }} defer>
                    <ul className="timelineEditorAuxControls__listOfTracks">
                        {myStudioAudioPanel === 'sfx'
                            ? <ListOfSfxItems/> : null}
                        {myStudioAudioPanel === 'mix'
                            ? <ListOfMixItems/> : null}
                    </ul>
                </OverlayScrollbarsComponent>
                <button className="timelineEditorAuxControls__addNew" onClick={() => setShowUploadModal(true)}>
                    <PlusIcon/>
                </button>
                {showUploadModal && myStudioAudioPanel === 'sfx' && (
                    <ModalUploadCueSheetWithClip
                        projectId={projectId}
                        cueType="SFX"
                        headerText="Carica SFX"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
                {showUploadModal && myStudioAudioPanel === 'mix' && (
                    <ModalUploadCueSheetWithClip
                        projectId={projectId}
                        cueType="MIX"
                        headerText="Carica Mix"
                        onClose={() => setShowUploadModal(false)}
                    />
                )}
            </>
            : null
    );
};

export default AudioList;
